/**
 * Environment configuration
 * All environment variables should be accessed through this file
 */

const meta = import.meta.env;

export const env = {
  // API Configuration
  API_URL: (meta['VITE_API_URL'] as string | undefined) ?? 'http://localhost:8000',
  API_VERSION: (meta['VITE_API_VERSION'] as string | undefined) ?? 'v1',

  // App Configuration
  APP_NAME: (meta['VITE_APP_NAME'] as string | undefined) ?? 'TenpiGAD',
  APP_ENV: meta.MODE ?? 'development',

  // Feature Flags
  ENABLE_MOCKS: meta['VITE_ENABLE_MOCKS'] === 'true',

  // Helpers
  isDevelopment: meta.DEV,
  isProduction: meta.PROD,
} as const;

// Type for environment variables
export type Env = typeof env;
